import { render, staticRenderFns } from "./machineTranslateManageList.vue?vue&type=template&id=4cda3b6f&scoped=true"
import script from "./machineTranslateManageList.vue?vue&type=script&lang=js"
export * from "./machineTranslateManageList.vue?vue&type=script&lang=js"
import style0 from "./machineTranslateManageList.vue?vue&type=style&index=0&id=4cda3b6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cda3b6f",
  null
  
)

export default component.exports